import React from "react";
import styled from "styled-components";
import { lightThemeColors } from "../../assets/style/colors";
import BenefitItem from "../generic/BenefitItem";

const AppGrowMostBenefits = () => {
  const benefits = [
    "Precisely track campaign effectiveness and user acquisition",
    "Boost user retention and engagement through personalized experiences",
    "Eliminate friction from user journeys to increase conversions",
    "Clearly demonstrate ROI from every marketing dollar spent",
  ];
  return (
    <FullPageContainer>
      <Container id={"dataDriven"}>
        <TextWrapper>
          <Title>Who Benefits Most from Grovs?</Title>
        </TextWrapper>
        <Content>
          <ItemsWrapper>
            <ItemsTitle>
              Grovs is perfect for app marketers, growth managers, and product
              teams who need to:
            </ItemsTitle>
            {benefits.map((item, index) => (
              <BenefitItem key={index} benefit={true} text={item} />
            ))}
          </ItemsWrapper>
        </Content>
      </Container>
    </FullPageContainer>
  );
};

export default AppGrowMostBenefits;

const FullPageContainer = styled.div`
  display: flex;
  width: 100%;
  background: ${lightThemeColors.background};
  position: relative;
`;

const Container = styled.div`
  width: 100%;
  max-width: 1512px;
  margin-left: auto;
  margin-right: auto;
  z-index: 1;
  display: flex;
  flex-direction: column;
padding:100px 80px;
  gap: 40px;
  overflow: hidden;
  @media (max-width: 990px) {
    padding: 20px;
    gap: 30px;
  }
`;

const Content = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  gap: 30px;
  justify-content: center;
  z-index: 2;
  @media (max-width: 990px) {
    flex-direction: column;
    align-items: center;
  }
`;
const Title = styled.h1`
  color: ${lightThemeColors.darkColor};
  font-size: 36px;
  font-weight: 700;
  line-height: 46px;
  @media (max-width: 990px) {
    font-size: 30px;
    line-height: 36px;
    text-align: center;
  }
`;
const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 30px;
  margin: auto;
`;

const ItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 600px;
  gap: 20px;
`;
const ItemsTitle = styled.p`
  color: ${lightThemeColors.darkColorFaded};
  font-weight: 400;
  font-size: 20px;
  line-height: 30px;
`;
